// Generates simulated telemetry data for demo sessions.

function generateTrackPoint(i, totalPoints, lapNum) {
  const t = i / totalPoints;
  const angle = t * Math.PI * 2;

  // Oval-ish track shape with some variation
  const rx = 0.012;
  const ry = 0.005;
  const wobble = Math.sin(angle * 3) * 0.001;
  const lat = 29.1855 + Math.sin(angle) * (ry + wobble);
  const lng = -81.069 + Math.cos(angle) * (rx + wobble * 0.5);

  // Speed profile: slower in turns, faster on straights
  const turnFactor = Math.abs(Math.sin(angle * 2));
  const baseSpeed = 80 + (1 - turnFactor) * 90;
  const speed = baseSpeed + (Math.random() - 0.5) * 5 - lapNum * 0.3;

  // G-forces derived from track shape
  const lateralG = Math.sin(angle * 2) * 1.8 + (Math.random() - 0.5) * 0.2;
  const longG = -Math.cos(angle * 2) * 1.2 + (Math.random() - 0.5) * 0.15;

  return {
    dist: (i / totalPoints) * 3.56,
    speed: Math.max(40, speed),
    lateralG,
    longG,
    lat,
    lng,
    time: (i / totalPoints) * (78 + lapNum * 0.5 + Math.random() * 2),
  };
}

function generateLap(lapNum, totalLaps) {
  const pointsPerLap = 200;
  const data = [];
  for (let i = 0; i < pointsPerLap; i++) {
    data.push(generateTrackPoint(i, pointsPerLap, lapNum));
  }

  const lapTime = 78 + lapNum * 0.4 + Math.random() * 3 - 1;
  const s1 = lapTime * 0.32 + (Math.random() - 0.5) * 0.5;
  const s2 = lapTime * 0.35 + (Math.random() - 0.5) * 0.5;
  const s3 = lapTime - s1 - s2;

  return {
    lapNum,
    lapTime: parseFloat(lapTime.toFixed(3)),
    sectors: [parseFloat(s1.toFixed(3)), parseFloat(s2.toFixed(3)), parseFloat(s3.toFixed(3))],
    data,
  };
}

export function generateSessionData(session) {
  // TODO: Replace with real Cloud Storage fetch
  const lapCount = session.lapCount || 12;
  const laps = [];
  for (let i = 1; i <= lapCount; i++) {
    laps.push(generateLap(i, lapCount));
  }

  return {
    sessionId: session.sessionId,
    track: session.track,
    car: session.car,
    date: session.date,
    laps,
  };
}

// Overlay smoothed channel values onto each sample's top-level fields when
// present, so all charts/analysis use smoothed data. Channel-agnostic: it
// copies whatever keys are in `smooth` (today speed/lat/lng/alt/hdg; future
// additions like lateralG/longG are picked up automatically). Channels absent
// from `smooth` are left as their raw values. A no-op for sessions without a
// `smooth` object (older uploads).
export function applySmoothedSamples(laps) {
  if (!Array.isArray(laps)) return laps;
  return laps.map((lap) => {
    if (!lap || !Array.isArray(lap.data)) return lap;
    return {
      ...lap,
      data: lap.data.map((s) =>
        s && s.smooth && typeof s.smooth === 'object' ? { ...s, ...s.smooth } : s
      ),
    };
  });
}

export function getMaxSpeed(sessionData) {
  if (!sessionData?.laps?.length) return { value: 0, lapNum: null };
  let max = 0;
  let lapNum = null;
  for (const lap of sessionData.laps) {
    for (const pt of lap.data) {
      if (pt.speed > max) { max = pt.speed; lapNum = lap.lapNum; }
    }
  }
  return { value: max, lapNum };
}

export function getMaxG(sessionData) {
  if (!sessionData?.laps?.length) return { lateral: 0, long: 0, latLapNum: null, longLapNum: null };
  let maxLat = 0;
  let maxLong = 0;
  let latLapNum = null;
  let longLapNum = null;
  for (const lap of sessionData.laps) {
    for (const pt of lap.data) {
      if (Math.abs(pt.lateralG) > maxLat) { maxLat = Math.abs(pt.lateralG); latLapNum = lap.lapNum; }
      if (Math.abs(pt.longG) > maxLong) { maxLong = Math.abs(pt.longG); longLapNum = lap.lapNum; }
    }
  }
  return { lateral: maxLat, long: maxLong, latLapNum, longLapNum };
}
